import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import { ListItemRenderer } from './ListItemRenderer';
import locales from '../../locales/LocalesManager';
import platformDetection from '../utils/PlatformDetection';
import properties from '../../constants/Properties';
import appParameters from '../../components/utils/AppParameters';
import videoUtils from '../utils/VideoUtils';
import { OnOffToggleButton } from '../menus/OnOffToggleButton';
import masterUniverseUtils from '../utils/MasterUniverseUtils';

const ListContent = React.createClass({
    getInitialState() {
        return {
            elements: [],
            refreshHandlers: []
        };
    },
    componentDidMount() {
        videoUtils.refreshItemRenderer = undefined;
        this.initElements();
    },
    initElements() {
        let elements = [];
        let items = this.props.dataProvider;
        let noBackgroundTitle = locales.getCaption('NoBackground', 'other');

        if (this.props.isBackground && items.length > 0) {
            const item = items[items.length - 1];

            if (item.blankBackground == true) {
                // is already set
            } else {
                let noBackgroundItem = {};
                noBackgroundItem.logicalName = '';
                noBackgroundItem.title = noBackgroundTitle;
                noBackgroundItem.noBackground = true;
                noBackgroundItem.xlinkHref = '';
                noBackgroundItem.frameLabel = '';
                noBackgroundItem.moods = [];
                noBackgroundItem.blankBackground = true;
                noBackgroundItem.isVideo = false;

                items.push(noBackgroundItem);
            }
        }

        let i;
        let backgroundColor = 'white';

        if (appParameters.newClipartId == 59681267 || (appParameters.default && appParameters.default.newClipartId == 59681267)) { // Space universe ... workaround for CH-249
            if (this.props.index == 3)
                backgroundColor = 'lightsteelblue';
        }

        for (i=0; i<items.length; i++) {
            const item = items[i];
            elements.push(<ListItemRenderer item={item} backgroundColor={backgroundColor} key={'listElements' + (i+1)} isBackground={this.props.isBackground} isMediaFiles={this.props.isMediaFiles} index={i} addRefreshHandler={this.addRefreshHandler} parentWidth={this.props.width}/>);
        }

        this.setState({
            elements,
            refreshHandlers: []
        });
    },
    addRefreshHandler(handler, index) {
        if (!masterUniverseUtils.useThumbnailsLazyLoading())
            return;

        this.state.refreshHandlers[index] = handler;
    },
    updateScroll(scrollTop) {
        if (!masterUniverseUtils.useThumbnailsLazyLoading())
            return;

        if (!this.state.refreshHandlers)
            return;

        for (var i=0; i<this.state.elements.length; i++) {
            if (this.state.refreshHandlers[i])
                this.state.refreshHandlers[i](scrollTop);
        }
    },
    shouldComponentUpdate(newProps, nextState) {
        var dinamicDataProvider = (this.props.activeButton != newProps.activeButton  || this.props.oldActiveButton != newProps.oldActiveButton);

        if (this.state.elements != nextState.elements || this.props.width != newProps.width || this.props.windowHeight != newProps.windowHeight || dinamicDataProvider || this.props.useBackgroundAsImage != newProps.useBackgroundAsImage || this.props.useVideoAsBackground != newProps.useVideoAsBackground)
            return true;
        else
            return false;
    },
    render() {
        if (this.state == undefined || this.state.elements == undefined)
            return (<div/>);

        let displayState = 'none';

        if ((this.props.index == this.props.activeButton || this.props.index == this.props.oldActiveButton) && (this.props.dataProvider.length > 0))
            displayState = 'inline-block';

        const paddingTop = 5;
        const paddingLeft = 3;

        var componentProperties = {};
        componentProperties.paddingTop = paddingTop;
        componentProperties.paddingLeft = paddingLeft;
        componentProperties.width = this.props.width;
        componentProperties.top = this.props.top;
        componentProperties.displayState = displayState;

        const listHeight = this.props.windowHeight - this.props.itemsLength * properties.BROWSER_BUTTON_HEIGHT - this.props.topButtonsOffset;
        componentProperties.height = listHeight - 15;

        if (this.props.isBackground && this.props.dataProvider.length > 0) {
            if (platformDetection.isTouchableDevice() == false)
                componentProperties.paddingTop = 13;
        }

        if (masterUniverseUtils.useThumbnailsLazyLoading()) {
            if (this.props.index == this.props.activeButton)
                componentProperties.elements = this.state.elements;
            else
                componentProperties.elements = [];

            componentProperties.updateScrollHandler = this.updateScroll;
        } else {
            componentProperties.elements = this.state.elements;
        }

        var onOffButton;

        if ((this.props.isBackground && this.props.clipartCategory === 0) || this.props.clipartCategory === 1) {
            var topGap = 5;
            var bottomGap = 2;
            var onOffButtonProperties = {};

            onOffButtonProperties.topPosition = componentProperties.top + topGap;
            onOffButtonProperties.leftPosition = properties.MY_MEDIA_FILES_GAP;
            onOffButtonProperties.trackWidth = properties.TOGGLE_TRACK_WIDTH;
            onOffButtonProperties.trackHeight = properties.TOGGLE_TRACK_HEIGHT;
            onOffButtonProperties.thumbHref = appParameters.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
            onOffButtonProperties.thumbSize = properties.TOGGLE_THUMB_SIZE;
            onOffButtonProperties.dispatch = this.props.dispatch;
            onOffButtonProperties.width = properties.BROWSER_WIDTH - 2 * properties.MY_MEDIA_FILES_GAP;

            if (this.props.clipartCategory === 1) {
                onOffButtonProperties.useVideoAsBackground = this.props.useVideoAsBackground;
                onOffButtonProperties.isMediaFilesElement = true;
                onOffButtonProperties.isVideo = true;
            } else {
                onOffButtonProperties.isBackgroundElement = true;
                onOffButtonProperties.useBackgroundAsImage = this.props.useBackgroundAsImage;
            }

            onOffButton = <OnOffToggleButton properties={onOffButtonProperties} dispatch={this.props.dispatch}/>;

            var toggleButtonHeight = onOffButtonProperties.thumbSize + topGap + bottomGap;

            componentProperties.top = componentProperties.top + toggleButtonHeight;
            componentProperties.height = componentProperties.height - toggleButtonHeight;

            return (
                <div>
                    {onOffButton}
                    <ScrollableComponent componentProperties={componentProperties}/>
                </div>
            );
        } else {
            return (
                <ScrollableComponent componentProperties={componentProperties}/>
            );
        }
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var accordionWidth = state.accordion.width;
    var useBackgroundAsImage = state.menu.useBackgroundAsImage;
    var useVideoAsBackground = state.menu.useVideoAsBackground;

    if (useBackgroundAsImage == undefined)
        useBackgroundAsImage = false;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    if (useVideoAsBackground == undefined)
        useVideoAsBackground = true;

    var activeButton = state.accordion.activeButton;
    var oldActiveButton = state.accordion.oldActiveButton;

    if (!activeButton || activeButton < 0)
        activeButton = 0;

    if (!oldActiveButton)
        oldActiveButton = -1;

    return {
        width: accordionWidth,
        activeButton,
        oldActiveButton,
        useBackgroundAsImage,
        useVideoAsBackground
    };
}

export const List = connect(mapStateToProps)(ListContent);



/** WEBPACK FOOTER **
 ** ./src/components/accordion/List.js
 **/